import { Controller } from "stimulus";
import disableElement from "../functions/disableElement";
import enableElement from "../functions/enableElement";

/*
 * Use this controller to enable or disableElements based
 * on some kind of state change in the store.
 *
 * This controller will:
 * on connect: Fetch state from the store and set this as the current and disabled
 * state. The targets wil be disabled.
 *
 * It will then listen for sync events to the storeKey value of the store.
 * When this sync differs from the disabledState, it will enable the untouchable targets
 * and update the current state.
 *
 */

export default class extends Controller {

  static targets = [
    "untouchable"
  ];

  static values = {
    storeKey: String,
    disabledState: { type: Array, default: [] }
  };

  connect() {
    this._requestState();
  }


  _requestState() {
    this.dispatch("requestState", {
      detail: { id: this.storeKeyValue, requesterId: this._id },
      prefix: false,
    });
  }

  loadInitialState({ detail: { requesterId, values } }) {
    if (requesterId === this._id) {
      if (values === undefined) {
        values = []; 
      }

      this.currentState = values;

      this.updateUntouchableTargets();
    }
  }

  resetInitialState() {
    this.currentState = [];
    this.updateUntouchableTargets();
  }

  // Intercept store syncs here
  updateElementsFromSync({ detail: { id, values } }) {
    if (id === this.storeKeyValue) {
      this.currentState = values;
      this.updateUntouchableTargets();
    }
  }

  updateUntouchableTargets() {
    if (this.disableUntouchableTargets) {
      this.untouchableTargets.forEach(button => {
        disableElement(button);
      });
    } else {
      this.untouchableTargets.forEach(button => {
        enableElement(button);
      });
    }
  }

  get disableUntouchableTargets() {
    // Key value order is relevant to comparison here.
    // This is safe to do as values from the DOM will be json compatible
    return JSON.stringify(this.currentState) === JSON.stringify(this.disabledStateValue);
  }

  get _id() {
    return `${this.identifier}-${this.element.id}`;
  }
}
